export default "__VITE_ASSET__CTns$nKB__"